export default __webpack_public_path__ + "static/ibis-508bf213be4625d18bbb469f66074bd8.png";